'use strict';
import BasePickerController from './mx-picker-base-controller';

export default class PickerCtrl extends BasePickerController {
	static $inject = ['$timeout', '$q', '$element', '$scope', 'mx.internationalization'];

	constructor($timeout, $q, $element, $scope, i18n) {
		super($timeout, $q, $element, $scope, i18n);
		this.single = true;
	}

	_onAutoCompleteItemSelected(value) {
		this.model = value;
	}

	setSelectedItems(items = []) {
		this.selectedItem = items.length ? items[0] : null;
	}

	selectedItemsToValue() {
		return this.selectedItem ? this.getId(this.selectedItem) : null;
	}

	onDblClick() {
		const input = this.$element.find('input')[0];
		input.focus();
		input.setSelectionRange(0, input.value.length);
	}
}
